"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _marshaler = _interopRequireDefault(require("../util/marshaler"));

var _apiKeys = _interopRequireDefault(require("./api-keys"));

var _collaborators = _interopRequireDefault(require("./collaborators"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Organizations = /*#__PURE__*/function () {
  function Organizations(api) {
    (0, _classCallCheck2["default"])(this, Organizations);
    this._api = api;
    this.ApiKeys = new _apiKeys["default"](api.OrganizationAccess, {
      parentRoutes: {
        get: 'organization_ids.organization_id',
        list: 'organization_ids.organization_id',
        create: 'organization_ids.organization_id',
        update: 'organization_ids.organization_id'
      }
    });
    this.Collaborators = new _collaborators["default"](api.OrganizationAccess, {
      parentRoutes: {
        get: 'organization_ids.organization_id',
        list: 'organization_ids.organization_id',
        set: 'organization_ids.organization_id'
      }
    });
  } // Retrieval.


  (0, _createClass2["default"])(Organizations, [{
    key: "getAll",
    value: function () {
      var _getAll = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(params, selector) {
        var response;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this._api.OrganizationRegistry.List(undefined, _objectSpread(_objectSpread({}, params), _marshaler["default"].selectorToFieldMask(selector)));

              case 2:
                response = _context.sent;
                return _context.abrupt("return", _marshaler["default"].payloadListResponse('organizations', response));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getAll(_x, _x2) {
        return _getAll.apply(this, arguments);
      }

      return getAll;
    }()
  }, {
    key: "getById",
    value: function () {
      var _getById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(id, selector) {
        var fieldMask, response;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                fieldMask = _marshaler["default"].selectorToFieldMask(selector);
                _context2.next = 3;
                return this._api.OrganizationRegistry.Get({
                  routeParams: {
                    'organization_ids.organization_id': id
                  }
                }, fieldMask);

              case 3:
                response = _context2.sent;
                return _context2.abrupt("return", _marshaler["default"].payloadSingleResponse(response));

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getById(_x3, _x4) {
        return _getById.apply(this, arguments);
      }

      return getById;
    }()
  }, {
    key: "search",
    value: function () {
      var _search = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(params, selector) {
        var response;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this._api.EntityRegistrySearch.SearchOrganizations(undefined, _objectSpread(_objectSpread({}, params), _marshaler["default"].selectorToFieldMask(selector)));

              case 2:
                response = _context3.sent;
                return _context3.abrupt("return", _marshaler["default"].payloadListResponse('organizations', response));

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function search(_x5, _x6) {
        return _search.apply(this, arguments);
      }

      return search;
    }() // Creation.

  }, {
    key: "create",
    value: function () {
      var _create = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(userId, organization) {
        var response;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this._api.OrganizationRegistry.Create({
                  routeParams: {
                    'collaborator.user_ids.user_id': userId
                  }
                }, {
                  organization: organization
                });

              case 2:
                response = _context4.sent;
                return _context4.abrupt("return", _marshaler["default"].payloadSingleResponse(response));

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function create(_x7, _x8) {
        return _create.apply(this, arguments);
      }

      return create;
    }() // Update.

  }, {
    key: "updateById",
    value: function () {
      var _updateById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(id, patch) {
        var mask,
            response,
            _args5 = arguments;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                mask = _args5.length > 2 && _args5[2] !== undefined ? _args5[2] : _marshaler["default"].fieldMaskFromPatch(patch);
                _context5.next = 3;
                return this._api.OrganizationRegistry.Update({
                  routeParams: {
                    'organization.ids.organization_id': id
                  }
                }, {
                  organization: patch,
                  field_mask: _marshaler["default"].fieldMask(mask)
                });

              case 3:
                response = _context5.sent;
                return _context5.abrupt("return", _marshaler["default"].payloadSingleResponse(response));

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function updateById(_x9, _x10) {
        return _updateById.apply(this, arguments);
      }

      return updateById;
    }() // Deletion.

  }, {
    key: "deleteById",
    value: function () {
      var _deleteById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(organizationId) {
        var response;
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this._api.OrganizationRegistry.Delete({
                  routeParams: {
                    organization_id: organizationId
                  }
                });

              case 2:
                response = _context6.sent;
                return _context6.abrupt("return", _marshaler["default"].payloadSingleResponse(response));

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function deleteById(_x11) {
        return _deleteById.apply(this, arguments);
      }

      return deleteById;
    }()
  }, {
    key: "purgeById",
    value: function () {
      var _purgeById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(organizationId) {
        var response;
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this._api.OrganizationRegistry.Purge({
                  routeParams: {
                    organization_id: organizationId
                  }
                });

              case 2:
                response = _context7.sent;
                return _context7.abrupt("return", _marshaler["default"].payloadSingleResponse(response));

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function purgeById(_x12) {
        return _purgeById.apply(this, arguments);
      }

      return purgeById;
    }() // Miscellaneous.

  }, {
    key: "getRightsById",
    value: function () {
      var _getRightsById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8(organizationId) {
        var result;
        return _regenerator["default"].wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this._api.OrganizationAccess.ListRights({
                  routeParams: {
                    organization_id: organizationId
                  }
                });

              case 2:
                result = _context8.sent;
                return _context8.abrupt("return", _marshaler["default"].unwrapRights(result));

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function getRightsById(_x13) {
        return _getRightsById.apply(this, arguments);
      }

      return getRightsById;
    }() // Events stream.

  }, {
    key: "openStream",
    value: function () {
      var _openStream = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee9(identifiers, tail, after) {
        var payload;
        return _regenerator["default"].wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                payload = {
                  identifiers: identifiers.map(function (id) {
                    return {
                      organization_ids: {
                        organization_id: id
                      }
                    };
                  }),
                  tail: tail,
                  after: after
                };
                return _context9.abrupt("return", this._api.Events.Stream(undefined, payload));

              case 2:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function openStream(_x14, _x15, _x16) {
        return _openStream.apply(this, arguments);
      }

      return openStream;
    }()
  }]);
  return Organizations;
}();

var _default = Organizations;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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